import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { FeatureImagePlaceholder } from "@/components/FeatureImagePlaceholder";

interface FeatureImageFrameProps {
  /** Bronafbeelding. Leeg of ontbrekend: dan rendert het placeholderkader. */
  src?: string | null;
  alt?: string | null;
  /** Kleur van de radiale gradient achter de afbeelding. */
  color?: string;
  className?: string;
  loading?: "lazy" | "eager";
  /** Eigen beeldnode (bijv. EditableImage) in plaats van een gewone img. */
  children?: ReactNode;
}

/**
 * Gedeeld beeldkader voor hero's en featureblokken op de platformpagina's.
 * Vaste breedte 448px en vaste aspect-ratio 4/3 met object-fit cover, zodat
 * elke rij dezelfde hoogte heeft. Zonder src valt het kader terug op het
 * lila placeholderkader.
 */
export function FeatureImageFrame({
  src,
  alt,
  color = "#F3EDFD",
  className,
  loading = "lazy",
  children,
}: FeatureImageFrameProps) {
  const hasImage = Boolean(children) || Boolean(src);

  return (
    <div
      className={cn("w-full max-w-[448px] rounded-2xl overflow-hidden relative", className)}
      style={{
        background: `radial-gradient(circle at center, white 0%, ${color} 70%)`,
        border: "10px solid rgba(255, 255, 255, 0.7)",
      }}
    >
      <div className="w-full aspect-[4/3] relative z-10">
        {children ? (
          children
        ) : hasImage ? (
          <img
            src={src as string}
            alt={alt || ""}
            loading={loading}
            className="w-full h-full object-cover rounded-2xl"
          />
        ) : (
          <FeatureImagePlaceholder />
        )}
      </div>
    </div>
  );
}
